import { ObjectUtil } from '@ddt-web/generic-utils';

import { GridChartUtil } from '../utils/grid-chart.util';
import { DefaultChartConfig } from './default-chart.config';
import { ChartType } from './enums/chart-type.enum';
import { GridChartCustomAttributes } from './grid-chart-custom-attributes.interface';

declare const Highcharts;

const DEFAULT_GRID_CHART_CONFIG: any = {
	legend: {
		enabled: true,
		verticalAlign: 'top',
		itemStyle: {
			fontSize: '14px',
			lineHeight: '21px'
		},
		y: -2
	},
	plotOptions: {
		series: {
			pointPadding: 0.15
		}
	},
	tooltip: {
		headerFormat: '<b>{point.series.name}</b>',
		pointFormat: '{point.tooltip}'
	},
	xAxis: {
		labels: {
			enabled: false
		},
		plotLines: [
			{
				color: '#ddd',
				width: 1,
				value: -0.51
			}
		],
		tickLength: 0,
		title: {
			enabled: false
		}
	},
	yAxis: {
		gridLineWidth: 0,
		labels: {
			enabled: false
		},
		title: {
			enabled: false
		}
	}
};

export class GridChartConfig extends DefaultChartConfig {
	constructor(
		protected type: ChartType,
		protected name: string,
		protected container: HTMLElement,
		protected data: any,
		protected dataIndex?: number,
		protected colors?: Array<string>,
		protected height?: number,
		protected width?: number,
		protected title?: string,
		protected hideTitle?: boolean,
		protected x?: string,
		protected y?: string,
		protected customAttributes?: GridChartCustomAttributes
	) {
		super(type, container, colors, height, width, title, hideTitle);
		this.initialize();
	}

	private initialize(): void {
		this.configuration = ObjectUtil.extend(this.configuration, DEFAULT_GRID_CHART_CONFIG);
		this.customAttributes = ObjectUtil.extend(DEFAULT_GRID_CUSTOM_ATTRRIBUTES, this.customAttributes);
		this.customAttributes = GridChartUtil.reconcileAttributes(this.customAttributes);
		this.configuration.chart.height = GridChartUtil.recalculateHeight(this.customAttributes);
		this.configuration.chart.width = GridChartUtil.recalculateWidth(this.customAttributes);
		this.updateDefaultConfiguration();
	}

	public render(): void {
		if (!this.name) {
			this.renderDefaultChart();
		}
	}

	private updateDefaultConfiguration(): void {
		this.configuration = ObjectUtil.extend(this.configuration, {
			chart: {
				events: {
					load: (self, arg) => {
						const ren = self.target.renderer;
						const attr = this.customAttributes;
						// loop through how many nodes to display
						for (let i = 0; i < attr.numberOfNode; i++) {
							ren
								// draw rectangle (pos x, pos y, width, height)
								.rect(
									(i % attr.nodesPerRow) * (attr.nodeSize + attr.spaceBetweenNode), // pos x = column in row * space each node need
									Math.floor(i / attr.nodesPerRow) * (attr.nodeSize + attr.spaceBetweenNode), // pos y = row num * space each node need
									attr.nodeSize,
									attr.nodeSize
								)
								.attr({
									padding: attr.spaceBetweenNode,
									fill: GridChartUtil.getColorByRow(Math.floor(i / attr.nodesPerRow) + 1, attr)
								})
								.add();
						}
					}
				}
			}
		});
	}
	public getConfigurationForPDF(): any {
		return this.configuration;
	}
	private renderDefaultChart(): void {
		Highcharts.chart(this.configuration);
	}
}
const DEFAULT_GRID_CUSTOM_ATTRRIBUTES: GridChartCustomAttributes = {
	numberOfNode: 100,
	nodesPerRow: 15,
	nodeSize: 10,
	spaceBetweenNode: 5,
	redColor: 0,
	greenColor: 0,
	blueColor: 0,
	fade: false,
	fadeStart: 0,
	maximumNumberOfRow: 0
};
